import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Box from 'components/atoms/Layout/Box/Box';

const StyledAvatarOption = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.layout('1sp')};

  &.AvatarOption-reverse {
    flex-direction: row-reverse;
  }
  
  ${ComponentStyles}
`;

StyledAvatarOption.propTypes = {
  theme: PropTypes.object
};

export default StyledAvatarOption;
